'use client'

import { useEffect, useRef, useState } from 'react'

const VIDEO_SRC = '/mascot/satbuddy-mechanic.webm'
const SAFARI_SRC = '/mascot/satbuddy-mechanic.webp'

/**
 * The mechanic mascot with a transparent background. Safari plays WebM but drops
 * its transparency, so it gets the animated WebP instead. Renders nothing until
 * mounted so the choice never causes a hydration mismatch.
 */
export function MascotMedia({ className }: { className?: string }) {
    const videoRef = useRef<HTMLVideoElement>(null)
    const [mode, setMode] = useState<'video' | 'image' | null>(null)

    useEffect(() => {
        const isSafari = /^((?!chrome|chromium|android|crios|fxios).)*safari/i.test(navigator.userAgent)
        setMode(isSafari ? 'image' : 'video')
    }, [])

    useEffect(() => {
        if (mode === 'video' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            videoRef.current?.pause()
        }
    }, [mode])

    if (mode === 'video') {
        return (
            <video ref={videoRef} className={className} autoPlay muted loop playsInline preload="auto" aria-hidden="true">
                <source src={VIDEO_SRC} type="video/webm" />
            </video>
        )
    }
    if (mode === 'image') {
        // eslint-disable-next-line @next/next/no-img-element
        return <img src={SAFARI_SRC} alt="" className={className} />
    }
    return null
}
